import { http, HTTP_URL } from '@/assets/js/api'
import Popup from '@/components/activity/liwan/popup'
import TopTip from '@/components/activity/coupon2/TopTip'

/* 活动组件：领取弹窗 顶部提示 初始化  */
export const activityMixin = {
  components: {
    Popup,
    TopTip
  },
  data () {
    return {
      receiving: false
    }
  },
  created () {},
  methods: {
    // 需传入参数和回调
    initData (params = {}, formatData = function () {}) {
      let channel = sessionStorage.getItem('channel') || ''
      channel && (params.channel = channel)
      http({
        url: HTTP_URL.activityHandle,
        params
      }).then(res => {
        formatData(res)
      })
    },
    // 点击领取
    getCoupon (item) {
      if (item.is_get) {
        this.showTopTip('您已经领取过该优惠券了')
        return
      }
      if (this.receiving) {
        this.showTopTip('正在领取中，请稍候...')
        return
      }
      this.receiving = true
      this.sendCouponRuq(item)
    },
    // 领取弹窗
    showPopupHandle (text) {
      this.couponText = text
      this.popupShow('popupSuccess')
    },
    popupShow (ref) {
      this.$refs[ref].$el.classList.add('active')
    },
    // 顶部提示
    showTopTip (text) {
      this.topTipText = text
      this.$refs.topTip.show()
    }
  }
}
